import React, { useState } from 'react';
import show from '../assets/show.svg'
import hide from '../assets/hide.svg'

export default function PassShowHide({ ...props }) {
    const [view, setView] = useState(false)
    function handleChange(event) {
        event.preventDefault()
        setView(!view)
    }
    return (
        <>
            <input {...props} type= {view ? "text" : "password"} />
            <img className="passSH" src={view ? show : hide} alt="icon" width="24" height="24" onClick={event => handleChange(event)} href='.' />
        </>
    )

}